<template>
  <section id="partners">
    <div class="row d-sm-none mt-1">
        <div class="col-12 our-partners">
            <span>Nuestros Partners</span>
        </div>
        <div class="wprt-lines style-2 custom-1 col-12">
            <div class="line-1"></div>
        </div>
        <div class="col-3 offset-1 col-sm-4 col-xs-6 partner">
            <img src="@/assets/platforms/ifood.png" alt="iFood">
        </div>
        <div class="col-4 col-sm-4 col-xs-6 partner">
            <img src="@/assets/platforms/picap.png" alt="Picap">
        </div>
        <div class="col-3 col-sm-4 col-xs-6 partner">
            <img src="@/assets/platforms/rappi.png" alt="Rappi">
        </div>
        <div class="col-3 offset-1 col-sm-4 col-xs-6 partner">
            <img src="@/assets/platforms/mensajeros.png" alt="Mensajeros Urbanos">
        </div>
        <div class="col-4 col-sm-4 col-xs-6 partner">
            <img src="@/assets/platforms/la_manicurista.png" alt="La Manicurista">
        </div>
        <div class="col-3 col-sm-4 col-xs-6 partner">
            <img src="@/assets/platforms/domicilios.png" alt="Logysto">
        </div>
        <get-your-credit-button :form-url="formUrl" :sold-out="soldOut"></get-your-credit-button>
    </div>

    <div class="row d-none d-sm-flex mt-1">
        <div class="col-12 our-partners mb-2">
            <span>Nuestros Partners</span>
        </div>
        <div class="col-2 partner">
            <img src="@/assets/platforms/ifood.png" alt="iFood">
        </div>
        <div class="col-2 partner">
            <img src="@/assets/platforms/picap.png" alt="Picap">
        </div>
        <div class="col-2 partner">
            <img src="@/assets/platforms/rappi.png" alt="Rappi">
        </div>
        <div class="col-2 partner">
            <img src="@/assets/platforms/mensajeros.png" alt="Mensajeros Urbanos">
        </div>
        <div class="col-2 partner">
            <img src="@/assets/platforms/la_manicurista.png" alt="La Manicurista">
        </div>
        <div class="col-2 partner">
            <img src="@/assets/platforms/domicilios.png" alt="Logysto">
        </div>
        <get-your-credit-button :form-url="formUrl" :sold-out="soldOut"></get-your-credit-button>
    </div>
  </section>
</template>

<script>
import GetYourCreditButton from './partials/GetYourCreditButton'
export default {
  name: 'Partners',
  components: {GetYourCreditButton},
  props: {
    formUrl: '',
    soldOut: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
.our-partners {
  height: 42px;
  color: #333333;
  font-family: "Source Serif Pro";
  font-size: 2rem;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 42px;
  text-align: center;
}
section.partners {
    padding: 100px 50px;
}

div.partner {
    text-align: center;
    margin-top: 20px;
}

.partner > img{
    width: 60px;
    height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/Partners.vue